"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _Flex = require("../../../Layout/Flex");

var _Typography = require("../../Typography");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-right: 15px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 14px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  min-height: 135px;\n  padding: 0 24px;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ListItem = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject(), _Constant.Color.GREY_2);
var ActionIconItem = (0, _styledComponents.default)(_Flex.FlexItem)(_templateObject2());
var Description = (0, _styledComponents.default)(_Flex.FlexItem)(_templateObject3());
var TextItemContainer = (0, _styledComponents.default)(_Flex.FlexItem)(_templateObject4());

var SidebarSubListItem = function SidebarSubListItem(_ref) {
  var actionIcon = _ref.actionIcon,
      header = _ref.header,
      description = _ref.description,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["actionIcon", "header", "description"]);
  return /*#__PURE__*/_react.default.createElement(ListItem, (0, _extends2.default)({
    alignItems: "center"
  }, rest), /*#__PURE__*/_react.default.createElement(TextItemContainer, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography.SpecificityHeader, null, header), /*#__PURE__*/_react.default.createElement(Description, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography.Legal, null, description))), /*#__PURE__*/_react.default.createElement(ActionIconItem, null, /*#__PURE__*/_react.default.createElement("img", {
    src: actionIcon,
    alt: "action"
  })));
};

SidebarSubListItem.propTypes = {
  header: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  actionIcon: _propTypes.default.string.isRequired
};
var _default = SidebarSubListItem;
exports.default = _default;